import React, { useState, useEffect, Suspense } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import { 
  MessageCircle, TrendingUp, Users, CheckCircle2, 
  Smartphone, Zap, ChevronDown, PlayCircle, 
  Star, ShieldCheck, ArrowRight, FileText, 
  Database, UserCheck, Lock, XCircle, Code
} from 'lucide-react';
import { getLocation } from "../utils/GetLocation";
import { trackMetaEvent } from "../utils/MetaPixel";
import InscriptionModal from "../modals/InscriptionModal";
import PromoModal from "../modals/PromoModal";
import WhatsAppButton from "../header/WhatsAppButton";
import coursesData from "../../data/CourseData";
import VisitorPopup from "../utils/VisitorPopup";
import logogarantia from "../../assets/img/sello_garantia.webp";

const PresalePrices = ({ values, currency }) => (
  <div className="text-sm mt-2 text-slate-400">
    {values?.map((v, i) => (
      <div key={i}>{v.fecha}: {currency} {v.valor}</div>
    ))}
  </div>
);
const imgHeader = "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1200&q=80";

const CourseWhatsAppLP = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // 🔹 Buscamos curso por ID
  const course = coursesData.find((c) => c.id === id);

  const phoneNumber = "573014953565";
  const message = encodeURIComponent(
    `Hola, leí todo el contenido de la página web del ${course?.typeTitle} "${course?.titleMain}" y quiero inscribirme con la promoción de la página web pero aún tengo dudas y quisiera resolverlas`
  );
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  // Estados visuales
  const [openFaq, setOpenFaq] = useState(null);
  const [openModule, setOpenModule] = useState(0); 
  const [isScrolled, setIsScrolled] = useState(false);

  // Estados lógicos de negocio
  const [showModal, setShowModal] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [price, setPrice] = useState({ oldPrice: "", newPrice: "", currency: "" });
  const [country, setCountry] = useState("us");
  const [presalePrices, setPresalePrices] = useState({});

  let countryValues = 'us';

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Modales
  const handleShowModal = (id) => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleClosePromoModal = () => setShowPromoModal(false);
  const handleConfirmPromoModal = () => {
    setShowPromoModal(false);
    handleShowModal();
    trackMetaEvent("Lead", { from: "PromoModal", content_name: course?.titleMain });
  };

  // Mostrar Modal Promo por tiempo
  useEffect(() => {
    let timer;
    if (course) {
      const hasSeenModal = sessionStorage.getItem(`promoModalSeen_${course.id}`);
      if (course.modalOffer && !hasSeenModal) {
        timer = setTimeout(() => {
          setShowPromoModal(true);
          sessionStorage.setItem(`promoModalSeen_${course.id}`, 'true');
        }, 15000);
      }
    }
    return () => clearTimeout(timer);
  }, [course]);

  // --- Precios según ubicación ---
    useEffect(() => {
      getLocation().then(({ countryCode }) => {
        const resolvedCountry = countryCode || 'us';
        setCountry(resolvedCountry);
        countryValues = course.values[countryCode] || course.values["us"]; // Si el país no está definido, usa USD
        setPrice({ oldPrice: countryValues.oldPrice.toLocaleString("de-DE"), newPrice: countryValues.newPrice.toLocaleString("de-DE"), priceInscription: ((countryValues.newPrice) * 0.6).toLocaleString("de-DE"), currency: countryValues.currency, priceFormat: countryValues.newPrice, priceUpsel: countryValues.newPrice * 0.80 });
        setPresalePrices(countryValues?.presale)
      });
    }, [course.values]);

  // Pixel Tracking de vista
  useEffect(() => {
    if (course) {
      trackMetaEvent("ViewContent", {
        content_name: course.titleMain,
        content_category: `${course.type} Online`,
        content_ids: [course.id],
      });
    }
  }, [course]);

  const toggleFaq = (index) => setOpenFaq(openFaq === index ? null : index);
  const toggleModule = (index) => setOpenModule(openModule === index ? null : index);

  const scrollToPricing = (e) => {
    e.preventDefault();
    document.getElementById('oferta').scrollIntoView({ behavior: 'smooth' });
  };

  if (!course) return <div className="text-center py-20 text-white bg-[#020617] min-h-screen">Curso no encontrado</div>;

  if (!course.active) {
    return (
      <div className="bg-[#020617] min-h-screen text-white">
        <div className="w-full relative min-h-[300px] mb-5 overflow-hidden">
          <img src={imgHeader} alt="Encabezado" className="absolute top-0 left-0 w-full h-full object-cover z-0" loading="eager" />
          <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-10"></div>
          <div className="container mx-auto relative z-20 px-6">
            <div className="flex flex-col justify-center h-full min-h-[300px]">
              <h3 className="text-4xl font-light text-white uppercase tracking-wider mb-2">Detalles del curso</h3>
              <div className="flex items-center text-white text-sm uppercase">
                <Link to="/" className="hover:text-[#25D366]">Inicio</Link>
                <span className="mx-3">»</span>
                <span>Detalles del curso</span>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto py-10 px-6 text-center">
          <h2 className="bg-red-600 text-white font-bold p-4 rounded-lg inline-block mb-4 shadow-lg">
            El curso aún no está disponible, pero muy pronto abriremos inscripciones. 🎉
          </h2>
          <h3 className="text-slate-300 mt-4 text-xl">Atento al lanzamiento los próximos días para obtener el precio de PREVENTA.</h3>
          <button onClick={() => navigate("/")} className="mt-8 px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-full transition-colors">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>
      </div>
    );
  }

  // Iconos rotativos para dolores y beneficios para dar variedad visual
  const painIcons = [<Users />, <TrendingUp className="transform rotate-180"/>, <MessageCircle />, <XCircle />, <Code />];
  const benefitIcons = [<FileText />, <Database />, <ShieldCheck />, <CheckCircle2 />, <Users />, <Zap />];

  return (
    <div id="import-course-lp" className="min-h-screen bg-[#020617] text-slate-200 font-sans selection:bg-[#25D366] selection:text-white pb-10">
      
      <style>{`
        .bg-pattern {
          background-image: radial-gradient(rgba(37, 211, 102, 0.15) 1px, transparent 1px);
          background-size: 30px 30px;
        }
        .text-glow-green { text-shadow: 0 0 30px rgba(37, 211, 102, 0.5); }
        .glass-card {
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.05);
        }
        .whatsapp-gradient { background: linear-gradient(135deg, #128C7E 0%, #25D366 100%); }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        .animate-float { animation: float 6s ease-in-out infinite; }
      `}</style>

       {/* NAVBAR */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#020617]/90 backdrop-blur-md border-b border-white/10 py-2 md:py-3 shadow-lg' : 'bg-transparent py-3 md:py-5'}`}>
        <div className="max-w-6xl mx-auto px-6 flex justify-center md:justify-between items-center">
          <div className="hidden md:flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <span className="font-bold text-xl tracking-tight text-white">Dissemp<span className="text-blue-500">Academy</span></span>
          </div>
          <button onClick={scrollToPricing} className="bg-[#25D366] hover:bg-[#1ebd57] text-white px-6 py-2 rounded-full text-sm font-bold transition-all shadow-[0_0_15px_rgba(37,211,102,0.4)]">
            Inscribirme Ahora
          </button>
        </div>
      </nav>

      {/* Hook Banner Superior */}
      <div className="bg-red-600 text-white text-center font-bold py-2 text-sm sm:text-base fixed top-[60px] md:top-[68px] left-0 right-0 z-40 animate-pulse tracking-wide shadow-lg">
        {course.hookMain}
      </div>

      {/* HERO SECTION */}
      <section className="relative pt-36 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-pattern">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#25D366]/10 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="max-w-6xl mx-auto px-6 relative z-10 flex flex-col lg:flex-row items-center gap-12 mt-4 md:mt-0">
          
          <div className="lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#25D366]/10 border border-[#25D366]/30 text-[#25D366] text-xs md:text-sm font-bold mb-6 uppercase tracking-wider">
              <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse"></span>
              {course.typeTitle}
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight leading-[1.1] mb-6">
              {course.hook.map((part, index) => (
                <span key={index} style={{color: part.style.color === 'black' ? 'white' : part.style.color}} className={part.style.color === '#25D366' ? 'text-glow-green' : ''}>
                  {part.text}{" "}
                </span>
              ))}
            </h1>
            
            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl font-light leading-relaxed mx-auto lg:mx-0">
              {course.subtitle}
            </p>

                   {/* SECCIÓN NUEVA: Fecha de Inicio (UBICACIÓN CORREGIDA) */}
            {course.startDate && (
              <div className="flex justify-center lg:justify-start mb-8">
                <div className="inline-flex items-center gap-3 bg-blue-900/40 border border-blue-500/50 py-3 px-6 rounded-xl shadow-[0_0_20px_rgba(59,130,246,0.3)] backdrop-blur-sm">
                  <Zap className="text-yellow-400 w-6 h-6 animate-pulse" />
                  <span className="text-white font-semibold md:text-lg">
                    <span className="text-slate-300 font-normal">Fecha de inicio: </span> {course.startDate}
                  </span>
                </div>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center">
              <button 
                onClick={(e) => {
                  scrollToPricing(e);
                }} 
                className="w-full sm:w-auto px-8 py-4 whatsapp-gradient hover:opacity-90 text-white font-black rounded-full transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(37,211,102,0.4)] flex items-center justify-center gap-2 text-lg"
              >
                {course.botonHookText} <ArrowRight className="w-5 h-5" />
              </button>
            </div>

            <div className="mt-10 flex items-center justify-center lg:justify-start gap-4">
              <div className="flex -space-x-3">
                <img src="https://i.pravatar.cc/100?img=1" alt="user" className="w-10 h-10 rounded-full border-2 border-[#020617]"/>
                <img src="https://i.pravatar.cc/100?img=2" alt="user" className="w-10 h-10 rounded-full border-2 border-[#020617]"/>
                <img src="https://i.pravatar.cc/100?img=3" alt="user" className="w-10 h-10 rounded-full border-2 border-[#020617]"/>
                <div className="w-10 h-10 rounded-full border-2 border-[#020617] bg-slate-800 flex items-center justify-center text-xs font-bold">+{course.students}</div>
              </div>
              <div className="text-sm">
                <div className="flex text-yellow-400">
                  <Star className="w-4 h-4 fill-current"/><Star className="w-4 h-4 fill-current"/><Star className="w-4 h-4 fill-current"/><Star className="w-4 h-4 fill-current"/><Star className="w-4 h-4 fill-current"/>
                </div>
                <span className="text-slate-400 font-medium">Alumnos satisfechos</span>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5 relative animate-float mt-8 lg:mt-0 hidden sm:block">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#25D366] to-blue-500 rounded-3xl rotate-6 opacity-30 blur-lg"></div>
            <div className="glass-card rounded-3xl p-6 relative border-t border-l border-white/20 shadow-2xl">
              {/* Mockup de Chat de WhatsApp */}
              <div className="bg-[#e5ddd5] rounded-2xl overflow-hidden shadow-inner flex flex-col h-[400px]">
                <div className="bg-[#075e54] text-white p-4 flex items-center gap-3">
                  <div className="w-10 h-10 bg-slate-300 rounded-full flex items-center justify-center overflow-hidden">
                    <img src="https://i.pravatar.cc/150?img=68" alt="Cliente"/>
                  </div>
                  <div>
                    <h3 className="font-bold text-sm text-white">Cliente Nuevo</h3>
                    <p className="text-xs text-white/80">en línea</p>
                  </div>
                </div>
                <div className="flex-1 p-4 bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-cover space-y-4 overflow-hidden">
                  <div className="bg-white text-slate-800 p-3 rounded-tr-xl rounded-b-xl max-w-[85%] text-sm shadow">
                    Hola, vi su anuncio. Quiero saber el precio
                  </div>
                  <div className="bg-[#dcf8c6] text-slate-800 p-3 rounded-tl-xl rounded-b-xl max-w-[85%] ml-auto text-sm shadow">
                    ¡Hola! Claro que si, para mi es un gusto atenderte. ¿Con quien tengo el gusto de hablar? 🎯
                  </div>
                  <div className="bg-white text-slate-800 p-3 rounded-tr-xl rounded-b-xl max-w-[85%] text-sm shadow">
                    Está un poco caro, lo voy a pensar...
                  </div>
                  <div className="bg-[#dcf8c6] text-slate-800 p-3 rounded-tl-xl rounded-b-xl max-w-[85%] ml-auto text-sm shadow relative">
                    <span className="absolute -left-20 top-2 bg-red-500 text-white text-[10px] font-bold px-2 py-1 rounded-full animate-bounce">¡ERROR!</span>
                    Ok, me avisas.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
 
      </section>

      {/* VSL SECTION */}
      {course?.vslLink && (
        <section className="bg-[#0a0f1c] py-16 border-y border-white/5 relative z-20">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <div className="relative w-full aspect-video bg-black rounded-2xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(37,211,102,0.3)] border border-slate-800">
                <iframe 
                  className="absolute top-0 left-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${course.vslLink}?rel=0&vq=hd720&modestbranding=1`} 
                  title="Video VSL" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* PAIN POINTS (Desde Data) */}
      <section className="py-24 bg-[#0a0f1c] border-b border-white/5 relative">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">La dura realidad de vender por WhatsApp</h2>
            <p className="text-slate-400">Si te pasa esto, estás perdiendo dinero todos los días.</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {course.paintPoints.map((point, i) => {
              const IconComponent = painIcons[i % painIcons.length];
              return (
                <div key={i} className="glass-card p-6 rounded-2xl flex items-start gap-4 hover:-translate-y-2 transition-transform duration-300">
                  <div className="flex-shrink-0 w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center">
                    {React.cloneElement(IconComponent, { className: "text-red-500 w-6 h-6", strokeWidth: 2.5 })}
                  </div>
                  <p className="text-slate-300 text-sm leading-relaxed mt-1">{point}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* SYLLABUS / MÓDULOS (Desde Data) */}
      <section className="py-24 relative">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">El Camino hacia el Cierre</h2>
            <p className="text-slate-400 text-lg">Más de 25 clases en video cortas y directas al grano. Sin relleno teórico.</p>
          </div>

          <div className="space-y-4">
            {course.modules && course.modules.length > 0 ? (
              course.modules.map((mod, index) => (
                <div key={index} className={`glass-card border rounded-2xl overflow-hidden transition-all duration-300 ${openModule === index ? 'border-[#25D366]' : 'border-slate-800'}`}>
                  <button 
                    onClick={() => toggleModule(index)}
                    className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none"
                  >
                    <div className="flex items-center gap-4">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 font-bold transition-colors ${openModule === index ? 'bg-[#25D366] text-slate-900' : 'bg-slate-800 text-slate-400'}`}>
                        {index + 1}
                      </div>
                      <div>
                        <h3 className={`font-bold text-lg text-black ${openModule === index ? 'text-white' : 'text-slate-300'}`}>{mod.title}</h3>
                        <p className="text-xs text-slate-500 mt-1 line-clamp-1 pr-4">{mod.content}</p>
                      </div>
                    </div>
                    <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${openModule === index ? 'rotate-180 text-[#25D366]' : 'text-slate-500'}`} />
                  </button>
                  
                  <div className={`px-6 overflow-hidden transition-all duration-500 ease-in-out bg-[#050b14] ${openModule === index ? 'max-h-[800px] py-6 opacity-100' : 'max-h-0 py-0 opacity-0'}`}>
                    <ul className="space-y-3">
                      {mod.lessons.map((lesson, i) => (
                        <li key={i} className="flex items-start gap-3 text-sm text-slate-300">
                          <CheckCircle2 className="w-5 h-5 text-[#25D366] shrink-0 mt-0.5" />
                          <span>{lesson.title}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-slate-400">Contenido en desarrollo...</div>
            )}
            
            {/* RETO FINAL */}
            <div className="mt-8 bg-gradient-to-r from-blue-900/40 to-purple-900/40 border border-blue-500/30 p-6 rounded-2xl flex items-center gap-4">
              <div className="bg-blue-500 p-3 rounded-full"><Zap className="text-white w-6 h-6"/></div>
              <div>
                <h3 className="font-bold text-white text-lg">RETO FINAL: Simulacro Integrador</h3>
                <p className="text-sm text-slate-300">Apliquemos todo lo aprendido en un caso real de principio a fin y ponte a prueba.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES (Mapeando los Benefits del Data) */}
      <section className="py-20 bg-[#0a0f1c] border-y border-white/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">El "Kit del Cerrador" <span className="text-[#25D366]">Incluido GRATIS</span></h2>
            <p className="text-slate-400">Inscríbete hoy y llévate estas herramientas listas para implementar.</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {course.benefits.slice(0,6).map((benefit, idx) => {
              // Extraer texto limpio sin emoji inicial si es posible
              const cleanText = benefit.replace(/^[^\w\s]+/, '').trim();
              const IconComponent = benefitIcons[idx % benefitIcons.length];
              return (
                <div key={idx} className="bg-[#020617] border border-slate-800 p-6 rounded-2xl flex flex-col items-center text-center hover:border-[#25D366]/50 transition-colors shadow-lg">
                  <div className="w-16 h-16 bg-[#25D366]/10 rounded-full flex items-center justify-center mb-4 border border-[#25D366]/20">
                    {React.cloneElement(IconComponent, { className: "text-[#25D366] w-8 h-8" })}
                  </div>
                  <h3 className="font-bold text-white text-lg mb-2 text-balance">{cleanText}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* INSTRUCTOR */}
      <section className="py-24 relative overflow-hidden">
        <div className="max-w-5xl mx-auto px-6">
          <div className="glass-card rounded-3xl p-8 md:p-12 border-t-4 border-t-blue-500 flex flex-col md:flex-row gap-10 items-center">
            <div className="md:w-1/3 relative">
              <div className="absolute inset-0 bg-blue-500 rounded-full blur-2xl opacity-20"></div>
              <img src={course.instructor.image} alt={course.instructor.name} className="rounded-full w-48 h-48 md:w-64 md:h-64 object-cover border-4 border-slate-800 relative z-10 mx-auto grayscale hover:grayscale-0 transition-all duration-500" />
            </div>
            <div className="md:w-2/3 text-center md:text-left">
              <h3 className="text-cyan-400 font-bold uppercase tracking-widest text-sm mb-2">Tu Instructor</h3>
              <h2 className="text-3xl font-black text-white mb-4">{course.instructor.name}</h2>
              <p className="text-slate-300 leading-relaxed mb-6 whitespace-pre-line">
                {course.instructor.bio}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING & CTA */}
      <section id="oferta" className="py-24 bg-[#0a0f1c] relative">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#25D366] to-transparent"></div>
        <div className="max-w-4xl mx-auto px-6">
          
          <div className="bg-[#020617] rounded-3xl border border-slate-800 shadow-2xl overflow-hidden relative">
            
            <div className="bg-gradient-to-r from-blue-900/40 to-[#020617] p-8 md:p-12 text-center border-b border-slate-800">
              <h2 className="text-3xl md:text-5xl font-black text-white mb-4">Acceso Total al Curso</h2>
              <p className="text-slate-400 text-lg">Un solo pago, acceso de por vida.</p>
              <div className="mt-4 bg-red-500/20 text-red-400 font-bold py-2 px-4 rounded-full inline-block text-sm border border-red-500/30">
                {course.SenseUrgency}
              </div>
            </div>

            <div className="p-8 md:p-12">
              <div className="flex flex-col md:flex-row gap-12 items-center">
                
                {/* Resumen Incluye */}
                <div className="flex-1 w-full space-y-4">
                  {course.includedCourse.slice(0,5).map((item, i) => (
                    <div key={i} className={`flex items-start gap-3 ${i === 4 ? 'bg-[#25D366]/10 p-2 rounded border border-[#25D366]/20' : ''}`}>
                      <CheckCircle2 className="text-[#25D366] w-5 h-5 shrink-0 mt-0.5"/> 
                      <span className={i === 4 ? "text-[#25D366] font-bold" : "text-slate-300"}>{item}</span>
                    </div>
                  ))}
                </div>

                {/* Caja de Precio */}
                <div className="flex-1 w-full text-center md:border-l md:border-slate-800 md:pl-12">
                  <p className="text-slate-500 line-through text-xl mb-1">{price.oldPrice} {price.currency}</p>
                  
                  {/* Lógica de Preventa vs Precio Normal */}
                  {course?.presale && !(course.values[country]?.presale) ? (
                     <div className="mb-6">
                        <p className="text-slate-400 text-sm mb-1 uppercase tracking-wide">Hoy por preventa:</p>
                        <div className="text-5xl md:text-6xl font-black text-[#25D366]">{price.newPrice} {price.currency}</div>
                     </div>
                  ) : (
                       <div className="mb-6">
                        <p className="text-slate-400 text-sm mb-1 uppercase tracking-wide">Hoy por preventa:</p>
                        <div className="text-5xl md:text-5xl font-black text-[#25D366]">{price.newPrice} {price.currency}</div>
                     </div>
                  )}

                  {/* Detalle de Fechas de Preventa si aplica */}
                  {course?.presale && !(course.values[country]?.presale) && presalePrices && (
                    <div className="mb-6 text-left bg-slate-900 rounded-lg p-3 border border-slate-800">
                      <PresalePrices values={presalePrices} currency={price.currency} isDarkTheme={true} />
                    </div>
                  )}
                  
                  <button onClick={() => {
                      handleShowModal();
                      trackMetaEvent('InitiateCheckout', { content_name: course.titleMain, content_ids: [course.id], currency: price.currency, value: price.newPrice });
                    }} 
                    className="w-full py-4 whatsapp-gradient hover:opacity-90 text-white font-black text-xl rounded-xl shadow-[0_0_20px_rgba(37,211,102,0.4)] transition-transform transform hover:scale-105 flex items-center justify-center gap-2"
                  >
                    Inscribirme Ahora <Lock className="w-5 h-5"/>
                  </button>
                  <p className="text-s text-slate-500 mt-4 flex items-center justify-center gap-1">
                    <ShieldCheck className="w-4 h-4"/> Pago 100% Seguro.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN NUEVA: GARANTÍA */}
      {course.id !== "10" && (
        <section className="py-20 bg-[#0a0f1c] border-y border-white/5 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-transparent pointer-events-none"></div>
          <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row items-center gap-10 relative z-10">
            <div className="md:w-1/3 flex justify-center">
              <img 
                src={logogarantia || "https://cdn-icons-png.flaticon.com/512/6556/6556817.png"} 
                alt="Garantía de 5 Días" 
                className="w-48 md:w-56 h-auto drop-shadow-[0_0_30px_rgba(250,204,21,0.2)] animate-float" 
              />
            </div>
            <div className="md:w-2/3 text-center md:text-left">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Garantía de Excelencia de 5 Días</h2>
              <div className="space-y-4">
                <p className="text-lg text-slate-300 leading-relaxed">
                  Con nuestro {course.type}, no solo aprenderás, lo harás con total confianza. 
                </p>
                <p className="text-lg text-slate-300 leading-relaxed">
                  💡 Si dentro de los primeros 5 días sientes que el curso no era lo que esperabas o te arrepientes de tu compra, <strong>te devolvemos el 80% de tu inversión</strong>. Sin hacer preguntas.
                </p>
                <div className="mt-6 inline-flex items-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 px-4 py-2 rounded-lg text-[#25D366] font-semibold">
                  <ShieldCheck className="w-5 h-5" /> Aprende sin miedo. Invierte sin riesgo.
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* SECCIÓN NUEVA: PREGUNTAS FRECUENTES (FAQ) */}
      {course?.faq && course.faq.length > 0 && (
        <section className="py-24 relative bg-[#020617]">
          <div className="max-w-3xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Preguntas Frecuentes</h2>
              <p className="text-slate-400 text-lg">Resolvemos tus dudas antes de empezar.</p>
            </div>

            <div className="space-y-4">
              {course.faq.map((item, index) => (
                <div key={index} className={`glass-card border rounded-2xl overflow-hidden transition-all duration-300 ${openFaq === index ? 'border-blue-500' : 'border-slate-800'}`}>
                  <button 
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none"
                  >
                    <span className={`font-bold pr-4 ${openFaq === index ? 'text-grey' : 'text-slate-300 text-black'}`}>
                      {item.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180 text-blue-500' : 'text-slate-500'}`} />
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 pb-0 opacity-0'}`}>
                    <p className="text-slate-400 leading-relaxed text-sm md:text-base">
                      {item.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* FOOTER */}
      <footer className="pt-16 pb-8 border-t border-white/5 text-center px-6">
        <div className="mb-8">
          <h3 className="text-xl font-bold mb-4 text-white">¿Aún tienes dudas y quieres resolverlas conmigo?</h3>
          <p className="text-slate-400 mb-6">Contáctanos por WhatsApp, estamos para ayudarte.</p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#1ebd57] text-white font-bold py-3 px-8 rounded-full transition-colors shadow-lg"
            onClick={() => trackMetaEvent('Lead', { content_name: course.titleMain, content_ids: [course.id] })}
          >
            <MessageCircle className="w-5 h-5" /> Chatear por WhatsApp
          </a>
        </div>
        <div className="border-t border-white/10 pt-8 mt-8">
          <span className="font-bold text-xl tracking-tight text-white opacity-50 block mb-4">Dissemp<span className="text-blue-500">Academy</span></span>
        </div>
      </footer>

      {/* COMPONENTES GLOBALES (Modales, botones flotantes) */}
      <WhatsAppButton course={course} />
      <VisitorPopup />
      
      {showPromoModal && (
        <PromoModal onClose={handleClosePromoModal} onConfirm={handleConfirmPromoModal} course={course} newPrice={price.newPrice} oldPrice={price.oldPrice} currency={price.currency} />
      )}
      
      <InscriptionModal show={showModal} handleClose={handleCloseModal} course={course} newPrice={price.newPrice} currency={price.currency} country={country} />

    </div>
  );
};

export default CourseWhatsAppLP;